import { render, staticRenderFns } from "./StudentRow.vue?vue&type=template&id=68f5b9c0&"
import script from "./StudentRow.vue?vue&type=script&lang=js&"
export * from "./StudentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports